import { connect } from 'react-redux'
import PreviewModal from './PreviewModal'
import { showSettingsModal } from '../../dataStore/actions/ui/uiActions'
import { selectors } from '@bt-react/store'
import { State } from '../../dataStore/reducers/reducerType'
import { PreviewModalProps } from './types'
import { SettingsTabs } from '../SettingsModal/types'
import selectPresenterMuted from '../../dataStore/selectors/selectPresenterMuted'
import selectPresenterHidden from '../../dataStore/selectors/selectPresenterHidden'
import selectIsLocalParticipantDialedIn from '../../dataStore/selectors/selectIsLocalParticipantDialedIn'
import selectPresenterBackground from '../../dataStore/selectors/selectPresenterBackground'

const getPresenterHidden = selectPresenterHidden()
const getPresenterMuted = selectPresenterMuted()
const getPresenterBackground = selectPresenterBackground()

const mapStateToProps = (state: State, props): Omit<PreviewModalProps, 'onPhoneClick'> => ({
  audioSource: state.tracks.audioSource,
  date: selectors.selectWebcast(state, `${state.config.channelId}${state.config.webcastId}`)['start'],
  isDialInEnabled: state.config.featureFlags.dialIn,
  isButtonDisabled: props.isButtonDisabled,
  onEnterClick: props.onEnterClick,
  onVirtualBackgroundsClick: props.onVirtualBackgroundsClick,
  isDialInConnected: selectIsLocalParticipantDialedIn(state),
  isHidden: getPresenterHidden(state, { presenter: { BTID: state.user.BTID }, ignoreRoom: true }),
  isMuted: getPresenterMuted(state, { presenter: { BTID: state.user.BTID }, ignoreRoom: true }),
  background: getPresenterBackground(state)
})

const mapDispatchToProps = dispatch => ({
  onPhoneClick: () => dispatch(showSettingsModal()),
  onVirtualBackgroundsClick: () => dispatch(showSettingsModal(SettingsTabs.VirtualBackgrounds))
})

export default connect(mapStateToProps, mapDispatchToProps)(PreviewModal)
